/* Cart drawer line-price patch: shows original vs discounted line price for
   automatic discounts (e.g. Core Cotton bundles).
   Sep 23 2026: (1) prices now formatted in the cart's own currency via
   theme.moneyFormat (was hard-coded to £, so EU/US drawers showed £);
   (2) no longer fetches /cart.js every 500ms on every page — it only fetches
   when the drawer's line items change or a cart request has just been made. */
(function(){
  function delims(cents, precision, thousands, decimal){
    var n = (cents/100).toFixed(precision); var parts = n.split('.');
    var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return d + (parts[1] ? decimal + parts[1] : '');
  }
  function fmt(cents, currency){
    try{
      var f = window.theme && window.theme.moneyFormat;
      if(f){
        f = String(f).replace(/<[^>]*>/g, '');
        var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
        if(m){
          var v;
          switch(m[1]){
            case 'amount_no_decimals': v = delims(cents,0,',','.'); break;
            case 'amount_with_comma_separator': v = delims(cents,2,'.',','); break;
            case 'amount_no_decimals_with_comma_separator': v = delims(cents,0,'.',','); break;
            case 'amount_with_apostrophe_separator': v = delims(cents,2,"'",'.'); break;
            case 'amount_with_space_separator': v = delims(cents,2,' ',','); break;
            default: v = delims(cents,2,',','.');
          }
          return f.replace(m[0], v);
        }
      }
    }catch(e){}
    try{ return new Intl.NumberFormat(document.documentElement.lang || undefined, {style:'currency', currency: currency}).format(cents/100); }catch(e){}
    return (cents/100).toFixed(2) + ' ' + (currency || '');
  }
  function patchCartDiscounts(cartData){
    const itemsByVariant={};
    cartData.items.forEach(item=>{itemsByVariant[item.variant_id]=item});
    document.querySelectorAll("li.crt-Push_Item").forEach(el=>{
      if(el.querySelector(".bs-discount-patch"))return;
      const link=el.querySelector("a.crt-PushItem_ImageContainer, a.crt-PushItem_TitleLink");
      if(!link)return;
      const match=link.href.match(/variant=(\d+)/);
      if(!match)return;
      const item=itemsByVariant[parseInt(match[1])];
      if(!item||item.original_line_price<=item.final_line_price)return;
      const priceEl=el.querySelector("p.crt-PushItem_Price");
      if(!priceEl)return;
      const patch=document.createElement("div");
      patch.className="bs-discount-patch";
      patch.style.cssText="display:flex;align-items:center;gap:6px;flex-wrap:wrap;";
      patch.innerHTML=`
        <span style="text-decoration:line-through;opacity:.5;font-size:.9em;">${fmt(item.original_line_price, cartData.currency)}</span>
        <span style="font-weight:600;">${fmt(item.final_line_price, cartData.currency)}</span>
        ${item.discounts.length?`<span style="font-size:.7em;background:#000;color:#fff;padding:1px 6px;border-radius:2px;">${item.discounts[0].title}</span>`:""}
      `;
      priceEl.replaceWith(patch);
    });
  }
  var lastSig = null, busy = false;
  function signature(){
    var parts = [];
    document.querySelectorAll("li.crt-Push_Item").forEach(function(el){
      if(el.querySelector(".bs-discount-patch")) return;
      var link = el.querySelector("a.crt-PushItem_ImageContainer, a.crt-PushItem_TitleLink");
      var m = link && link.href.match(/variant=(\d+)/);
      var price = el.querySelector("p.crt-PushItem_Price");
      parts.push((m ? m[1] : '?') + ':' + (price ? price.textContent.trim() : ''));
    });
    return parts.join('|');
  }
  function refreshAndPatch(){
    if(busy) return;
    var sig = signature();
    if(!sig){ lastSig = ''; return; }
    if(sig === lastSig) return;
    busy = true;
    fetch("/cart.js", {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(c){ patchCartDiscounts(c); lastSig = signature(); })
      .catch(function(){})
      .then(function(){ busy = false; });
  }
  function isCartUrl(u){ return typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u); }
  var of = window.fetch;
  if(of){ window.fetch = function(){ var args = arguments, p = of.apply(this, args); try{ var a0 = args[0]; var url = (a0 && a0.url) ? a0.url : a0; if(isCartUrl(url)){ p.then(function(){ lastSig = null; }); } }catch(e){} return p; }; }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){ try{ if(isCartUrl(u)){ this.addEventListener('load', function(){ lastSig = null; }); } }catch(e){} return oo.apply(this, arguments); };
  setInterval(refreshAndPatch, 1000);
})();
